var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"silent-login-container"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-text"},[_vm._v("正在跳转微信授权...")])])])
}]

export { render, staticRenderFns }